// Jwalek logo mark - stylized 'J' with brand gradient
export const JwalekLogo = ({ size = 32, withWordmark = true, className = '' }) => {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <svg width={size} height={size * 1.15} viewBox="0 0 100 115" xmlns="http://www.w3.org/2000/svg" aria-label="Jwalek logo">
        <defs>
          <linearGradient id="jw-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E6248A" />
            <stop offset="35%" stopColor="#FF3D8A" />
            <stop offset="70%" stopColor="#FF6B35" />
            <stop offset="100%" stopColor="#FFA500" />
          </linearGradient>
        </defs>
        <path
          d="M85 5 L85 78 C85 98 68 110 48 110 C28 110 12 96 12 78 L12 68 L34 68 L34 78 C34 86 40 92 48 92 C56 92 62 86 62 78 L62 5 Z"
          fill="url(#jw-grad)"
        />
      </svg>
      {withWordmark && (
        <span className="font-display font-bold text-2xl tracking-tight" style={{ color: 'var(--jw-text)' }}>Jwalek</span>
      )}
    </div>
  );
};

export default JwalekLogo;
